import { useLang } from "../contexts/LanguageContext";
import { ShieldCheck } from "lucide-react";

export function CertificationsSection() {
  const { t } = useLang();
  const items = t.certifications.items;

  return (
    <section
      id="certifications"
      data-testid="certifications-section"
      className="px-6 md:px-12 lg:px-20 py-24 md:py-32 bg-background"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-16">
        <div className="md:col-span-5">
          <p className="tracking-eyebrow uppercase text-xs text-secondary mb-4">
            {t.certifications.eyebrow}
          </p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-balance">
            {t.certifications.title}
          </h2>
        </div>
        <div className="md:col-span-6 md:col-start-7 self-end">
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
            {t.certifications.lead}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-border">
        {items.map((item, idx) => (
          <div
            key={item.code}
            data-testid={`certification-${idx}`}
            className="bg-card p-8 space-y-4 hover:bg-accent/40 transition-colors"
          >
            <ShieldCheck strokeWidth={1.4} size={28} className="text-secondary" />
            <h3 className="font-display text-2xl leading-tight">{item.code}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {item.desc}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
